export default __webpack_public_path__ + "static/media/expansion.e1e96241.svg";